import Constant from "../constants/contant";

export const getDaysCountByWidth = (width: number): number => {
	if (width < 640) return 3;
	else if (width >= 639 && width < 840) return 5;
    else if (width >= 840 && width < 1025) return 7;
	else return 9;
};

export const isValidLang = (lang: string) => ['en', 'he', 'fr'].includes(lang);

// Utility function to truncate (trim) text to maximum stated characters
// If longer than stated number of characters the text will be trimmed only on a word boundary.
// Adds "…" at the end of trimmed text
export const truncateText = (text: string, charsNum: number) => {
	if (text.length <= charsNum) {
		return text;
	}
	else {
		const textTrimmed = text.slice(0, charsNum-1);
		return textTrimmed.slice(0, textTrimmed.lastIndexOf(" ")) + "...";
	}
}

export const engWeekDaysParser = (inputString: string) => {
	const matches = inputString.match(Constant.EN_WEEK_DAYS_REG_EX_PATTERNS);
	return matches ? matches[0] : null;
};

